import CustomColumns from './src/main.vue'
import type { App } from 'vue'

CustomColumns.install = function (app: App<Element>): void {
  app.component(CustomColumns.name!, CustomColumns)
}

export default CustomColumns


